// Copyright (c) 2020 Deere & Company

const oktaDevl = {
    issuer: 'https://sso-dev.johndeere.com/oauth2/ausi7tpzliZSTWOp10h7',
    clientId: '0oavwyebuhs1zgTTn0h7',
    scope: ['profile', 'openid']
};

const oktaQual = {
    issuer: 'https://sso-qual.johndeere.com/oauth2/ausi350kyb3DS4mMI0h7',
    clientId: '0oavwwopoerpTojRI0h7',
    scope: ['profile', 'openid']
};

const oktaCert = {
    issuer: 'https://sso-cert.johndeere.com/oauth2/aus97evo9eNxmWlTB1t7',
    clientId: '',
    scope: ['profile', 'openid']
};

const oktaProd = {
    issuer: 'https://sso.johndeere.com/oauth2/aus9fatalq0bxmt361t7',
    clientId: '0oaglab1ghKb8wZPY1t7',
    scope: ['profile', 'openid']
};

const jdProd = 'atp2.deere.com';
const jdProdTwo = 'atp.deere.com';
const jdProdAWS = 'atp-prod.deere.com';
const jdQual = 'atpqual.tal.deere.com';
const jdQual2 = 'atp-qual.deere.com';
// eslint-disable-next-line max-len
const jdQual3 = 'atp-qual.om-comar-apps-devl-vpn.us.e26.c01.johndeerecloud.com';
const jdCert = 'atp.cert.deere.com';

export const getOktaCredentials = () => {

    const currentHost = window.location.hostname;

    switch ( currentHost ) {

    case jdProd: return oktaProd;
    case jdProdTwo: return oktaProd;
    case jdProdAWS: return oktaProd;
    case jdQual: return oktaQual;
    case jdQual2: return oktaQual;
    case jdQual3: return oktaQual;
    case jdCert: return oktaCert;
    default: return oktaDevl;

    }

};
